import {getStartupParams} from 'helpers/startup-params.helper';

const startupParams = getStartupParams();
const screenWidth = startupParams && startupParams.width ? startupParams.width : window.innerWidth;

const isSetRestaurant = !!startupParams.id;

const isMobileDevice =
	/webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || screenWidth < 600;
const isExternalLoginMode = isSetRestaurant && !!startupParams.phone;

const isOpera =
	(navigator.userAgent.indexOf('Opera') !== -1 || navigator.userAgent.indexOf('OPR') !== -1) &&
	navigator.userAgent.indexOf('WebKit') === -1;

const isFirefox = navigator.userAgent.indexOf("Firefox") !== -1;

const isInternetExplorer = navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0;
const isNativeApp = !!global.cordova || !!global.PhoneGap || !!global.phonegap;

export default {
	isExternalLoginMode,
	isMobileDevice: isMobileDevice,
	isSetRestaurant,
	isSetApp: !!startupParams.app,
	isNativeApp,
	isHideHeader: !!startupParams['hide_header'],
	riseFooter: startupParams['rise_footer'] && Number(startupParams['rise_footer']),
	isAndroid: /android/gi.test(navigator.userAgent.toLowerCase()),
	isIOs: /iPhone|iPad|iPod/gi.test(navigator.userAgent.toLowerCase()),
	isIDevice: /iphone|ipad/gi.test(navigator.appVersion),
	isFirefox,
	isInternetExplorer,
	isPWA: navigator.standalone,
	initialUrl: window.location.href,

	windowResolution: () => {
		const screenResolutionAvailability = global && global.screen && global.screen.width && global.devicePixelRatio;
		return screenResolutionAvailability
			? global.screen.width * global.devicePixelRatio + 'x' + global.screen.height * global.devicePixelRatio
			: Math.max(document.documentElement.clientWidth, window.innerWidth || 0) +
			'x' +
			Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	},
	isBrowserSupported: () => {
		//don't check browsers if it is phonegap build
		if (isNativeApp) {
			return true;
		}

		if (isInternetExplorer) {
			return false;
		}

		if (isOpera) {
			return false;
		}

		if (navigator.userAgent.match(/Windows Phone [1-7]/i)) {
			return false;
		}

		return true;
	},
	getClasses() {
		const result = [];

		const platformPrefix = 'platform-';

		if (this.isIOs) {
			result.push(platformPrefix + 'ios');
		}

		if (this.isAndroid) {
			result.push(platformPrefix + 'android');
		}

		if (this.isPWA) {
			result.push(platformPrefix + 'pwa');
		}

		return result;
	},
	isPageInBackground(){
		if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
			return document.hidden;
		} else if (typeof document.msHidden !== "undefined") {
			return document.msHidden;
		} else if (typeof document.webkitHidden !== "undefined") {
			return document.webkitHidden;
		}

		return null;
	}
};
